import React from 'react'
import AppComponent from 'components/common/AppComponent'
import ChatVariablesTable from 'components/chatflows/ChatVariablesTable'

export default class ChatVariablesSelector extends AppComponent {

    constructor(props) {
        super(props);
    }


    handleSelected = (item) => {
        if (this.props.onSelected instanceof Function) {
            this.props.onSelected(item);
        }
    }

    render() {

        return (
            <React.Fragment>
                <div className="modal-head">
                    <h3>Select variable</h3>
                </div>
                <div className="modal-body">
                    <ChatVariablesTable
                        showCopyButton={this.props.showCopyButton}
                        showSelectButton={this.props.showSelectButton}
                        showCondVariables={this.props.showCondVariables}
                        showTextVariables={this.props.showTextVariables}
                        onSelected={(item) => this.handleSelected(item)}
                    />
                </div>
                <div className="modal-footer">
                    <div className="grid-x grid-padding-x">
                        <div className="small-12 cell">
                            <div className="btn-wrap">
                                <button className="button secondary" type="button" onClick={this.props.onCancel}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}